export class UfficioDTO {
  codice: string;
  nome: string;
}
